var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery6180(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "battery61_80_svg",
    "data-name": "battery61_80_svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t\t.cls-1-battery61_80 {\r\n\t\t\tfill: none;\r\n\t\t\t}\r\n\t\t\t\r\n\t\t\t.cls-1-battery61_80, .cls-2-battery61_80 {\r\n\t\t\tstroke: var(--input-text-color);\r\n\t\t\t}\r\n\t\t\t\r\n\t\t\t.cls-1-battery61_80, .cls-2-battery61_80, .cls-3-battery61_80 {\r\n\t\t\tstroke-miterlimit: 10;\r\n\t\t\tstroke-width: 35px;\r\n\t\t\t}\r\n\t\t\t\r\n\t\t\t.cls-2-battery61_80 {\r\n\t\t\tfill: var(--input-text-color);\r\n\t\t\t}\r\n\t\t\t\r\n\t\t\t.cls-3-battery61_80 {\r\n\t\t\tfill: var(--primary-color);\r\n\t\t\tstroke: var(--primary-color);\r\n\t\t\t}\r\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-battery61_80",
    x: 404.69587,
    y: 219.45096,
    width: 1110.60826,
    height: 1657.27433,
    rx: 86.96282
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-battery61_80",
    d: "M759.07766,35.17226h401.84467a45.8795,45.8795,0,0,1,45.8795,45.8795V219.451a0,0,0,0,1,0,0H713.19816a0,0,0,0,1,0,0V81.05176A45.8795,45.8795,0,0,1,759.07766,35.17226Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-battery61_80",
    x: 522.33808,
    y: 335.44783,
    width: 875.32384,
    height: 213.89492,
    rx: 19.49393
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3-battery61_80",
    x: 522.33808,
    y: 638.29425,
    width: 875.32384,
    height: 213.89492,
    rx: 19.49393
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3-battery61_80",
    x: 522.33808,
    y: 1546.8335,
    width: 875.32384,
    height: 213.89492,
    rx: 19.49393
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3-battery61_80",
    x: 522.33808,
    y: 1243.98708,
    width: 875.32384,
    height: 213.89492,
    rx: 19.49393
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3-battery61_80",
    x: 522.33808,
    y: 941.14066,
    width: 875.32384,
    height: 213.89492,
    rx: 19.49393
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery6180);
export default __webpack_public_path__ + "static/media/battery61_80.a0ae3ae8567eabdf4cf6c2b0ac8e61ab.svg";
export { ForwardRef as ReactComponent };